
import { Component, Vue, Prop } from 'vue-property-decorator';
  
import StepBase from "../StepBase.vue";
import { stepInfoType } from "@/types/Application";
import Notify from "./Notify.vue";
import ReviewYourAnswers from "./ReviewYourAnswers.vue";
import PreviewP1 from "./PreviewP1.vue";
import PreviewPgt from "./PreviewPgt.vue";
import PreviewP9 from "./PreviewP9.vue";
import TellPeople from "./TellPeople.vue";

import { namespace } from "vuex-class";   
import "@/store/modules/application";
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
const applicationState = namespace("Application");

@Component({
    components:{
        StepBase,        
        Notify,
        ReviewYourAnswers,
        PreviewP1,
        PreviewPgt,
        PreviewP9,
        TellPeople
    }
})

export default class NotifyStep extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;
    
};
